import type { GetReportingFlagsResponseAPI } from '@omnipresentgroup/types';

export const GET_REPORTING_FLAGS_RESPONSE: GetReportingFlagsResponseAPI = {
  enable_payroll_reports_tab: false,
};
